var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#FCF7F7",
    stroke: "#CAC2C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9331 19.976V21H11.0771V20.184L15.7331 15.624C16.3198 15.048 16.7145 14.552 16.9171 14.136C17.1305 13.7093 17.2371 13.2827 17.2371 12.856C17.2371 12.1947 17.0078 11.6827 16.5491 11.32C16.1011 10.9467 15.4558 10.76 14.6131 10.76C13.3011 10.76 12.2825 11.176 11.5571 12.008L10.7411 11.304C11.1785 10.792 11.7331 10.3973 12.4051 10.12C13.0878 9.84267 13.8558 9.704 14.7091 9.704C15.8505 9.704 16.7518 9.976 17.4131 10.52C18.0851 11.0533 18.4211 11.7893 18.4211 12.728C18.4211 13.304 18.2931 13.8587 18.0371 14.392C17.7811 14.9253 17.2958 15.5387 16.5811 16.232L12.7731 19.976H18.9331Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo2);
export default __webpack_public_path__ + "static/media/no2.33c8e6eaabf75226305a3c26484ce510.svg";
export { ForwardRef as ReactComponent };